import GoalsSerializer from './base';
import { isPresent } from '@ember/utils';

export default class Badge extends GoalsSerializer {
  normalize(modelClass, payload) {
    // normalise ids so that ember data doesn't complain.
    if (isPresent(payload.badgeAssertion)) {
      payload.badgeAssertion.assertionId = payload.badgeAssertion.id;

      if (isPresent(payload.badgeAssertion.badge)) {
        payload.badgeAssertion.badge.badgeId = payload.badgeAssertion.badge.id;

        if (isPresent(payload.badgeAssertion.badge.issuer)) {
          payload.badgeAssertion.badge.issuer.issuerId =
            payload.badgeAssertion.badge.issuer.id;
        }
      }
    }

    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);

    // push the item ids back into the record ids.
    if (isPresent(hash.badgeAssertion)) {
      hash.badgeAssertion.id = hash.badgeAssertion.assertionId;
      delete hash.badgeAssertion.assertionId;

      if (isPresent(hash.badgeAssertion.badge)) {
        hash.badgeAssertion.badge.id = hash.badgeAssertion.badge.badgeId;
        delete hash.badgeAssertion.badge.badgeId;

        if (isPresent(hash.badgeAssertion.badge.issuer)) {
          hash.badgeAssertion.badge.issuer.id =
            hash.badgeAssertion.badge.issuer.issuerId;
          delete hash.badgeAssertion.badge.issuer.issuerId;
        }
      }
    }

    return hash;
  }
}
